const updates = [
  { date: '07-31', title: '《星际征途：新纪元》4K版上线', desc: '年度科幻巨制高清版本现已就绪' },
  { date: '07-30', title: '《长安十二时辰之黎明》更新至第16集', desc: '热门古装悬疑剧集最新剧情推进' },
  { date: '07-29', title: '暑期档专题页面上线', desc: '精选暑期热门影视一站式观影入口' },
  { date: '07-28', title: '播放引擎升级至v3.2版本', desc: '进一步提升流畅播放体验和加载速度' },
  { date: '07-27', title: '《暗夜追踪者》1080P画质上线', desc: '硬汉动作片高清版本正式开放观看' },
  { date: '07-26', title: '新增12部纪录片资源', desc: '涵盖自然、历史、科技等热门题材' },
  { date: '07-25', title: '《来自星星的你2》更新至第8集', desc: '浪漫奇幻韩剧最新剧情引发热议' },
  { date: '07-24', title: '移动端访问体验优化', desc: '手机和平板观影更流畅更便捷' },
  { date: '07-23', title: '热门动漫新番专区上线', desc: '一站式浏览最新动漫和经典番剧作品' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[840px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              更新动态
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              最新影视资源上线和平台优化动态，不错过每一次更新
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

            <div className="space-y-5">
              {updates.map((item, idx) => (
                <a
                  key={idx}
                  href="#media"
                  className="group relative flex items-start gap-5 pl-12"
                >
                  <div className="absolute left-[13px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-primary-500 bg-background-100 group-hover:bg-primary-500 transition-colors"></div>
                  <div className="flex-shrink-0 w-14">
                    <span className="text-xs font-bold text-primary-600 bg-primary-100/70 px-2 py-1 rounded-md">
                      {item.date}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}